module.exports = __webpack_public_path__ + "img/waterpolo-dark.d8139dde.svg";